module.exports = __webpack_public_path__ + "img/shop_block_title.9c0c0c7d.png";